import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=60c94c56&scoped=true"
import script from "./authModal.vue?vue&type=script&lang=js"
export * from "./authModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c94c56",
  null
  
)

export default component.exports